import { Icon, Select } from '@pwc/pwc-deals-ui';
import React, { useEffect } from 'react';
import { useIngestionErrors } from './IngestionErrorProvider';
import {
  ErrorAction,
  ErrorActionType,
} from './PowerPointIngestionErrorHandling';
import { getPowerPointFileList } from '../../sharePointService';
import { safeErrors } from '../../../../common/services/httpClient';

const generateFileOptions = (pptFiles) => {
  return (pptFiles || []).map((file, index) => ({
    value: file.fileName,
    key: `${file.fileName}-${index}`,
  }));
};

export const PowerPointFileName = ({
  fileName,
  pptFiles,
  setFileName,
  setSlideNumber,
  setGroupName,
  setSelectedFileOption,
  projectId,
  setPptFiles,
  setIsLoading,
}) => {
  const [errorState, errorDispatch] = useIngestionErrors();
  const fileOptions = generateFileOptions(pptFiles);

  const handleFileNameChange = (value) => {
    const selectedFileOption = pptFiles.find((file) => file.fileName === value);
    if (pptFiles.find((file) => file.fileName === value)) {
      setSelectedFileOption(selectedFileOption);
    }
    errorDispatch(ErrorAction.Clear);
    setFileName(value);
    setSlideNumber('');
    setGroupName('');
  };

  const fileNameField = {
    name: 'powerpoint-file-search',
    value: fileName,
    onChange: (e) => handleFileNameChange(e.target.value),
  };

  useEffect(() => {
    const getFiles = async () => {
      setIsLoading(true);
      try {
        const files = await getPowerPointFileList(projectId);
        if (files.length === 0) {
          errorDispatch(ErrorAction.NoFilesInSharePointError);
        }
        setPptFiles(files);
        setIsLoading(false);
      } catch (e) {
        const errors = safeErrors(e.response);
        if (errors.length > 0) {
          errorDispatch({
            type: ErrorActionType.FILE_ERROR,
            value: errors[0].apiErrorMessage,
          });
        }
        setIsLoading(false);
      }
    };

    if (!pptFiles) {
      getFiles();
    }
  }, [errorDispatch, pptFiles, projectId, setIsLoading, setPptFiles]);

  return (
    <>
      <div className="text-input-control-label">File name</div>
      <div className="import-hint">
        <Icon
          name="information"
          className="fill icon-yellow"
          width={16}
          data-testid="hint-icon"
        />
        <p>
          The PowerPoint file must be saved to Sharepoint&apos;s &lsquo;Free
          Form PowerPoint&rsquo; folder to appear as an option here.
        </p>
      </div>
      <Select
        field={fileNameField}
        placeholder="Select file"
        data-testid="powerpoint-select"
        options={fileOptions}
        value={fileName}
        onChange={(event) => handleFileNameChange(event.target.value)}
        error={errorState.fileError}
        maxWidth="100%"
      />
    </>
  );
};
